import { defineMessages } from 'react-intl';
var messages = defineMessages({
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    NewTask: {
        id: 'NewTask',
        defaultMessage: 'New task',
    },
    WeekPlanner: {
        id: 'WeekPlanner',
        defaultMessage: 'Week planner',
    },
    ForEmployee: {
        id: 'ForEmployee',
        defaultMessage: 'For employee',
    },
    SelectTask: {
        id: 'SelectTask',
        defaultMessage: 'Select task',
    },
    Status: {
        id: 'Status',
        defaultMessage: 'Status',
    },
    ExecutionDateFrom: {
        id: 'ExecutionDateFrom',
        defaultMessage: 'Execution date from',
    },
    ExecutionDateUntil: {
        id: 'ExecutionDateUntil',
        defaultMessage: 'Execution date until',
    },
    TaskTemplates: {
        id: 'TaskTemplates',
        defaultMessage: 'Task templates',
    },
});
export default messages;
